import styled from "@emotion/styled"

import { rhythm } from "@utils/typography"

const Wrapper = styled.div`
  padding: ${rhythm(4)} 0;
`

export { Wrapper }
